export default __webpack_public_path__ + "static/media/baby.94903421.png";